import {Component} from "@angular/core";
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {TranslateService} from "@ngx-translate/core";
import {ReportParam} from "@domain/reporting/reportParam";
import {ConfirmService} from "@share/component/confirmation/confirm.service";
import {ReportingService} from "@services/admin/reporting/reporting.service";
import {ToastrService} from "ngx-toastr";
import {filter,first} from "rxjs/operators";
import {TypeCodeErreur} from "@domain/common/http/result";

/**
 * Composant pour afficher un param dans la liste
 */
@Component({
    host: {'data-test-id': 'report-param-item'},
    templateUrl: './report-param-item.component.html'
})
export class ReportParamItemComponent extends ListViewItem<ReportParam>{

    constructor(
        public translateService: TranslateService,
        private confirmService: ConfirmService,
        private reportingService: ReportingService,
        private toastrService: ToastrService) {
        super();
    }

    /**
     * Récupération de la valeur de l'avatar
     */
    avatar(): string {
        //Retour de la valeur de l'avatar
        return this.translateService.instant('admin.bibliotheque.reporting.infosReporting.parametres.avatar');
    }

    /**
     * Suppression du rôle
     */
    delete() {
        this.confirmService.showConfirm(this.translateService.instant('global.suppression.confirmation'))
            .pipe(filter(isConfirmed => isConfirmed))
            .subscribe({
                next: () => {
                    this.reportingService.deleteParam(this.extraOptions.idReport,this.data.name)
                        .pipe(first())
                        .subscribe(res => {
                            if (res.codeErreur !== TypeCodeErreur.NO_ERROR) {
                                //Si le résultat contient une erreur, alors on affiche un message d'erreur
                                this.toastrService.error(this.translateService.instant('global.errors.suppression'));
                            } else {
                                //Rafraichissement de la liste
                                this.extraOptions.refresh();

                                //Sinon, on affiche un message de succès
                                this.toastrService.success(this.translateService.instant('global.success.suppression'));
                            }
                        });
                }
            });
    }

    /**
     * Affichage des détails d'un paramètre
     */
    showParamDetails() {
        this.extraOptions.showParamDetails(this.data);
    }
}
